import { render, staticRenderFns } from "./config.vue?vue&type=template&id=3c669f4a"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c669f4a')) {
      api.createRecord('3c669f4a', component.options)
    } else {
      api.reload('3c669f4a', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=3c669f4a", function () {
      api.rerender('3c669f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/9-1-goods/config.vue"
export default component.exports